module.exports = __webpack_public_path__ + "img/genius.d3d2fb64.png";